export enum QuestionDisplayTypeEnum {
  default = "default",
  table = "table",
  select = "select",
}
